// Daily Reports are now React-driven; no global offcanvas click handler needed.

import { mountOnlineUsersWidget } from '../components/OnlineUsersWidget'
import { mountNotificationsBadge, mountNotificationsCenter } from '../components/NotificationsCenter'
import { mountProjectMilestonesTable } from '../components/ProjectMilestonesTable'
import { mountProjectForm } from '../components/ProjectForm'
import { mountMoneyInputs } from '../components/MoneyInput'
import { mountSidebarMenu } from '../components/SidebarMenu'
import { mountSharedLearnings } from '../components/SharedLearnings'
import { csrfToken } from '../utils/csrfToken'
import { initTooltips } from '../utils/tooltips'

function orgChartCard(el) {
  return el.closest('.card')
}

document.addEventListener('click', (event) => {
  const item = event.target.closest('[data-org-chart-user-id-param]')
  if (!item) return

  const card = orgChartCard(item)
  if (!card) return

  const directReportIdInput = card.querySelector('[data-org-chart-direct-report-id-input]')
  const submit = card.querySelector('[data-org-chart-submit]')
  const dropdownButton = card.querySelector('[data-org-chart-target="dropdownButton"]')

  const userId = item.dataset.orgChartUserIdParam
  const userName = item.dataset.orgChartUserNameParam
  const userEmail = item.dataset.orgChartUserEmailParam
  const userAvatar = item.dataset.orgChartUserAvatarParam

  if (directReportIdInput) directReportIdInput.value = userId || ''
  if (submit) submit.disabled = !userId

  if (dropdownButton && userId) {
    dropdownButton.innerHTML = `
      <span class="d-inline-flex align-items-center">
        <span class="avatar avatar-xs me-2" data-bs-toggle="tooltip" data-bs-title="${userName || userEmail || ''}">
          <img src="${userAvatar || ''}" class="avatar-img rounded-circle" alt="${userName || userEmail || ''}">
        </span>
        <span class="text-start">
          <div class="fw-semibold">${userName || ''}</div>
          <div class="small text-body-secondary">${userEmail || ''}</div>
        </span>
      </span>
    `

    initTooltips(card)
  }
})

document.addEventListener('submit', async (event) => {
  const form = event.target
  if (!(form instanceof HTMLFormElement)) return
  if (!form.dataset.orgChartAddDirectReportForm) return

  event.preventDefault()

  const directReportsContainerId = form.dataset.orgChartDirectReportsContainerId
  const unassignedUsersContainerId = form.dataset.orgChartUnassignedUsersContainerId

  const response = await fetch(form.action, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'X-CSRF-Token': csrfToken() || '',
    },
    body: new FormData(form),
    credentials: 'same-origin',
  })

  if (!response.ok) {
    // eslint-disable-next-line no-alert
    alert(`Failed to update org chart: ${response.status}`)
    return
  }

  const { direct_reports_html: directReportsHtml, unassigned_users_html: unassignedUsersHtml } =
    await response.json()

  if (directReportsContainerId) {
    const directReportsEl = document.getElementById(directReportsContainerId)
    if (directReportsEl) directReportsEl.innerHTML = directReportsHtml
  }

  if (unassignedUsersContainerId) {
    const unassignedUsersEl = document.getElementById(unassignedUsersContainerId)
    if (unassignedUsersEl) unassignedUsersEl.innerHTML = unassignedUsersHtml
  }
})

document.addEventListener('DOMContentLoaded', () => {
  const onlineWidget = document.querySelector('[data-online-users-widget]')
  if (onlineWidget) {
    mountOnlineUsersWidget(onlineWidget)
  }

  const notificationsCenter = document.querySelector('[data-notifications-center]')
  if (notificationsCenter) mountNotificationsCenter(notificationsCenter)

  const notificationsBadge = document.querySelector('[data-notifications-badge]')
  if (notificationsBadge) mountNotificationsBadge(notificationsBadge)

  const milestoneTables = document.querySelectorAll('[data-project-milestones-table]')
  milestoneTables.forEach((table) => mountProjectMilestonesTable(table))

  const projectForms = document.querySelectorAll('[data-project-form]')
  projectForms.forEach((form) => mountProjectForm(form))

  mountMoneyInputs()

  const sidebarMenu = document.querySelector('[data-sidebar-menu]')
  if (sidebarMenu) mountSidebarMenu(sidebarMenu)

  const sharedLearnings = document.querySelector('[data-shared-learnings]')
  if (sharedLearnings) mountSharedLearnings(sharedLearnings)

  initTooltips(document)
})
